export var initialStateProps = {
    authenticationStatus: "pending",
    authorizationLevel: "pending",
    accessLevel: "pending",
    sessionRefreshStatus: "pending",
    isSessionProcessing: false,
    shapeStatus: "pending",
    isFullyAuthenticated: false,
    isPartiallyAuthenticated: false
};
export default initialStateProps;
